import axios, { AxiosRequestConfig } from 'axios';

const URL = '/v2/admin/branch-worker'

class AdminBranchWorkerService {
  static delete(sitterId: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${URL}/${sitterId}`, config);
  }
}

export { AdminBranchWorkerService };
